<script setup lang="ts">
    import BaseButton from '@/components/BaseButton.vue';
    import useProductStore from '@/store/product.store';
    import iFrameApi from '@/api';
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';

    const { selectedProductConfiguration } = storeToRefs(useProductStore());

    const shinyVariant = computed(() => {
        return selectedProductConfiguration.value.isMat ? 'outlined' : 'filled';
    });

    const matVariant = computed(() => {
        return !selectedProductConfiguration.value.isMat ? 'outlined' : 'filled';
    });

    function setIsMat(isMat: boolean) {
        selectedProductConfiguration.value.isMat = isMat;
        iFrameApi.sendEvent('aspectChange', isMat ? 'mat' : 'shiny');
    }
</script>
<template>
    <div class="flex w-full flex-row">
        <BaseButton
            class="h-14 w-1/2"
            :variant="shinyVariant"
            @click="setIsMat(false)"
        >
            {{ $t('shiny_finish') }}
        </BaseButton>
        <BaseButton
            class="h-14 w-1/2"
            :variant="matVariant"
            @click="setIsMat(true)"
        >
            {{ $t('mat_finish') }}
        </BaseButton>
    </div>
</template>
